import React, {Component} from 'react';
import _ from "lodash";
import NoteForm from './NoteForm';
import Note from './Note';
import connect from "react-redux/es/connect/connect";
import {endLoading, startLoading} from "../../../actions/loadingActions";
import {removeNote} from "../../../actions/admin";

class NotesContainer extends Component{
    constructor(props){
        super(props);
    }
    renderNotes(){
        if(_.isEmpty(this.props.notes)){
            return(<div className="chat-nomessages"><i className="fa fa-sticky-note fa-5x"></i>No hay ninguna nota creada.</div>)
        }
        return this.props.notes.map((note) => {
            return (
                <Note
                    key={note.id}
                    note={note}
                    removeNote={this.props.removeNote}
                    startLoading={this.props.startLoading}
                />
            );
        })
    }

    render() {
        return (
            <div style={{marginTop: "30px"}}>
                <h4 className="text-secondary"><i className="text-primary fa fa-sticky-note-o" /> Notas internas </h4>
                <hr />
                {this.renderNotes()}
                <NoteForm />
            </div>
        );
    }
}

export default NotesContainer = connect(null, {
    startLoading,
    endLoading,
    removeNote
})(NotesContainer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/admin/notes/NotesContainer.jsx